import {
  IStatus_Created,
  IStatus_Started,
  IStatus_Error,
  IStatus_Timeout,
  IStatus_Complete,
} from './types/utils'

import {
  IAppLink,
} from './types/layout'

export const IS_DEVELOPMENT = process.env.NODE_ENV == 'development'
export const API_URL = '/api/v1'
export const REFRESH_TOKEN_DELAY = 1000 * 60

export const ROUTE_LOGGED_IN = 'dashboard'
export const ROUTE_LOGGED_OUT = 'login'

export const TOPBAR_HEIGHT = 90
export const APP_TITLE = 'panwww'
export const APP_LOGO = '/images/PAN-BLUE-LOGO-TINY.png'
export const APP_LOGO_HEIGHT_LARGE = 45
export const APP_LOGO_HEIGHT_SMALL = 30
export const APP_PALETTE = {
  primary: {
    main: '#5BA3CB',
  },
  secondary: {
    main: '#c99b46',
  },
  background: {
    paper: '#fff',
    default: '#fff'
  },
  text: {
    disabled: 'rgba(0, 0, 0, 0.38)',
    hint: 'rgba(0, 0, 0, 0.38)',
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.54)',
  }
}

export const APP_PALETTE_DARK = JSON.parse(JSON.stringify(APP_PALETTE))
APP_PALETTE_DARK.background = {
  paper: '#000',
  default: '#000'
}
APP_PALETTE_DARK.text = {
  disabled: 'rgba(255, 255, 255, 0.38)',
  hint: 'rgba(255, 255, 255, 0.38)',
  primary: 'rgba(255, 255, 255, 0.87)',
  secondary: 'rgba(255, 255, 255, 0.54)',
}

export const APP_TYPOGRAPHY = {
  fontFamily: `'EB Garamond', serif;`,
  fontWeight: 300,
}

export const ADMIN_USERS = [
  'kaiyadavenport@gmail.com',
]

export const STATUS_CREATED: IStatus_Created = 'created'
export const STATUS_STARTED: IStatus_Started = 'started'
export const STATUS_ERROR: IStatus_Error = 'error'
export const STATUS_TIMEOUT: IStatus_Timeout = 'timeout'
export const STATUS_COMPLETE: IStatus_Complete = 'complete'


export const APP_LINKS: IAppLink[] = [{
  title: 'Home',
  page: 'home',
}]